module.exports = __webpack_public_path__ + "assets/img/ma-logo-a5a24df8.png";